import {
  Box,
  Chip,
  Collapse,
  Dialog,
  DialogContent,
  Drawer,
  Grid2,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ORLOGO from "../assets/ORhorizontal.svg";
import "./layout.css";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useContext, useEffect, useState } from "react";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Dashboard from "../components/dashboard/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import Logout from "@mui/icons-material/Logout";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import { OnLogout } from "../redux/common/common.slice";
import { persistor } from "../redux/store";
import JobPosting from "../components/jobPostings/JobPostings";
import CandidateProfile from "../components/candidateProfiles/CandidateProfiles";
import Clients from "../components/clients/Clients";
import AddJobPostings from "../components/jobPostings/AddJobPostings";
import AddClient from "../components/clients/AddClient";
import AddCandidate from "../components/candidateProfiles/AddCandidate";
import AddProfile from "../components/jobPostings/AddProfile";
import ManageEventCandidate from "../components/candidateProfiles/ManageEventCandidate";
import JobManageEvents from "../components/jobPostings/JobManageEvents";
import ClientReferences from "../components/clientReferences/ClientReferences";
import AddClientReferences from "../components/clientReferences/AddClientReferences";
import Recruiters from "../components/Recruiters/Recruiters";
import RecruiterDetails from "../components/Recruiters/RecruiterDetails";
import Keywords from "../components/Keywords/Keywords";
import Reports from "../components/reports/Reports";
import PerformanceTracker from "../components/reports/PerformanceTracker";
import ManageEventsReports from "../components/reports/ManageEventsReports";
import Admin from "../components/Admin/Admin";
import AddAdmin from "../components/Admin/AddAdmin";
import DashboardManageEvents from "../components/dashboard/DashboardManageEvents";
import AuditLog from "../components/AuditLog/AuditLog";
import ChangePassword from "../components/changePassword/ChangePassword";
import { SnackbarContext } from "../reusable_components/components/Snackbar";
import RecruiterProfile from "../components/Profile/profile";
import Avatar from "@mui/material/Avatar";
import { deepPurple } from "@mui/material/colors";
import ViewJob from "../components/jobPostings/ViewJob";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import HomeLineIcon from "../assets/Icons/DashboardIcon";
import BarChartIcon from "../assets/Icons/JobsIcon";
import UsersIcon from "../assets/Icons/CandidatesIcon";
import UserIcon from "../assets/Icons/ClientsIcon";
import LetterSpacingIcon from "../assets/Icons/KeywordsIcon";
import UsersCheckIcon from "../assets/Icons/RecruitersIcon";
import UserCircleIcon from "../assets/Icons/AdminIcon";
import ReferralsIcon from "../assets/Icons/ReferralsIcon";
import ClipBoardCheckIcon from "../assets/Icons/ReportsIcon";
import FileIcon from "../assets/Icons/AuditLog";
import ViewClients from "../components/clients/ViewClients";
import ViewAdminCoordinators from "../components/Admin/ViewAdminCoordinators";
import ClientReferencesView from "../components/clientReferences/ClientReferencesView";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ClientReferrals from "../components/Referrals/ClientReferrals";
import CandidateReferrals from "../components/Referrals/CandidateReferrals";
import RefferlsIcon from "../assets/Icons/Referrals";
import ViewProfile from "../components/Profile/ViewProfile";
import ReferJobs from "../components/Recruiters/ReferJobs";
import Referrals from "../components/Referrals/Referrals";
import JobReferrals from "../components/Referrals/JobReferrals";
import NewReferrals from "../components/Referrals/NewReferrals";
import ReferralPayment from "../components/ReferralPayments/ReferralPayment";
import CandidateReferralPayment from "../components/ReferralPayments/CandidateReferralPayment";
import JobReferralPayment from "../components/ReferralPayments/JobReferralPayment";
import ViewPayments from "../components/ReferralPayments/ViewPayments";
import ViewCandidatePayments from "../components/ReferralPayments/ViewCandidatePayments";
import Payments from "../components/Payments/Payments";
import CommissionIcon from "../assets/Icons/CommissionIcon";
import PaymentIcon from "../assets/Icons/PaymentIcon";
import RecruiterProfileEdit from "../components/Recruiters/RecruiterProfileEdit";
import PaymentHistory from "../components/Payments/PaymentHistory";
import RecruiterProfileEditLv1 from "../components/Recruiters/RecruiterProfileEditLvl1";
import ViewCandidate from "../components/candidateProfiles/ViewCandidate";
import ClientReferralPayments from "../components/ReferralPayments/ClientReferralPayments";
import ViewClientPayment from "../components/ReferralPayments/ViewClientPayment";
import MsInstance from "../SocialLogin/MsInstance";
import Cookies from "js-cookie";
import UnAuthComponent from "../components/UnAuthorized/UnAuthComponent";
import ReferralCommison from "../components/ReferralPayments/ReferralCommission";
import OfferedCandidate from "../components/candidateProfiles/OfferedCandidate";
import SelectedCandidate from "../components/candidateProfiles/SelectedCandidate";
import ViewCommissions from "../components/ReferralPayments/ViewCommissions";
import AddRecruiter from "../components/Recruiters/AddRecruiter";
import ReferralPaymentNew from "../components/ReferralPayments/ReferralPaymentNew";
import UserChat from "../components/UserChat/UserChat";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import { useWebSocket } from "../stompClient/WebSocketProvider";
import { useGetPositionLevelDropDownQuery, useGetWorkCategoryDropDownQuery } from "../redux/Signup/signup.api";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CommissionManagement from "../components/commissionManagement/CommissionManagement";
import BAPerformance from "../components/Recruiters/BAPerformance";
import ClientHiringReport from "../components/reports/ClientHiringReport";
import { useRecruiterDeleteAccountMutation } from "../redux/Profile/profile.api";
import MUIButton from "../reusable_components/components/MUIButton";
import MUICancelButton from "../reusable_components/components/MuiCancelButton";
import { MessageCircleMore } from "lucide-react";

const DASHBOARD_PATH = "/dashboard";
const JOB_POSTINGS_PATH = "/jobpost";
const CANDIDATE_PROFILE_PATH = "/candidateprofile";
const CLIENT_PATH = "/client";
const VIEW_CLIENTS = "/client-view";
const ADD_CLIENT_PATH = "/client-add";
const ADD_JOB_POSTINGS_PATH = "/jobpostadd";
const EDIT_JOB_POSTINGS_PATH = "/jobpostedit/:id";
const JOB_MANAGE_EVENTS_PATH = "/manage-events/:id";
const ADD_CANDIDATE_PATH = "/addcandidateprofile";
const EDIT_CANDIDATE_PATH = "/editcandidateprofile/:id";
const EDIT_CLIENT_PATH = "/client-edit/:id";
const ADD_PROFILE_PATH = "/findprofile/:id";
const MANAGE_EVENT_CANDIDATE = "/manage-events-candidate/:id";
const CLIENT_REFERENCES_PATH = "/client-ref";
const ADD_CLIENT_REFERENCES_PATH = "/add-clientref";
const ADMIN_CLIENT_REFERENCES_PATH = "/admin-clientref/:id";
const EDIT_CLIENT_REFERENCES_PATH = "/edit-clientref";
const RECRUITERS_PATH = "/recruiter-list";
const RECRUITER_DETAILS_PATH = "/recruiter-details";
const RECRUITER_EDIT_PATH = "/recruiter-edit";
const RECRUITER_EDIT_PATH_LEVEL1 = "/recruiter-editLvl1";
const KEYWORDS_PATH = "/manage-keywords";
const REPORTS_PATH = "/reports";
const PERFORMANCE_TRACKER_PATH = "/reports/performanceTracker";
const MANAGE_EVENTS_REPORTS = "/reports/manageEventsReport";
const ADMIN = "/admin";
const ADD_ADMIN = "/add-admin";
const EDIT_ADMIN = "edit-admin/:id";
const DASHBOARD_MANAGEEVENTS_PATH = "/dashboard-manage-events/:id/:eventTypeId";
const AUDIT_LOG_PATH = "/audit-logs";
const CHNAGE_PASSWORD = "/change-password";
const PROFILE_PATH = "/profile";
const PROFILE_VIEW = "/profile-view";
const VIEW_JOB_PATH = "/submitprofiles/:id";
const VIEW_ADMIN_COORDINATORS = "/view-admin/co-ordinators/:id";
const VIEW_CLIENTS_REFERENCES = "/view-client-references/:id";
const CLIENT_REFERRALS = "/client-referrals";
const CANDIDATE_REFERRALS = "/candidate-referrals";
const JOB_REFERRALS = "/job-referrals";
const REFERRALS = "/referrals";
const VIEW_JOB_REFERRALS = "/referrals/submitprofiles/:id";
const EDIT_CANDIDATE_REFERRALS = "/referrals/editcandidateprofile/:id";
const VIEW_CLIENTS_REFERRALS = "/referrals/client-view";
const EDIT_JOB_POSTINGS_REFERRALS = "/referrals/jobpostedit/:id";
const EDIT_CLIENT_REFERRALS = "/referrals/client-edit/:id";
const MANAGE_EVENT_CANDIDATE_REFERRALS =
  "/referrals/manage-events-candidate/:id";
const REFER_JOBS = "/refer-jobs";
const VIEW_REFER_A_JOB = "/refer-jobs/submitprofiles/:id";
const NEW_REFERRALS = "/referrals/new-referrals";
const REFERRAL_PAYMENTS = "/referral-payments";
const REFERRAL_PAYMENT_SCREEN = "/referral-payments-new";
const JOB_REFERRAL_PAYMENT = "/Job/referral-payment";
const CANDIDATE_REFERRAL_PAYMENT = "/candidate/referral-payment";
const VIEW_PAYMENTS = "/view-job-payments";
const VIEW_CANDIDATE_PAYMENTS = "/view-candidate-payments";
const PAYMENTS = "/payments";
const REFER_A_JOB = "/refer-a-job";
const PAYMENT_HISTORY = "/payment-history";
const VIEW_CANDIDATE = "/candidate-view/:id";
const CLIENT_PAYMENT = "/client-payments";
const VIEW_CLIENT_PAYMENT = "/view-client-payment";
const DASHBOARD_JOB_OVERVIEW = "/dashboard/submitprofiles/:id";
const VIEW_COMMISSIONS = "/view-commissions";
const REFERRAL_COMMISSION = "/referral-commission";
const UN_AUTH_COMPONENT = "/unAuthorized-page";
const OFFERED_CANDIDATE = "/offeredCandidates";
const SELECTED_CANDIDATE = "/selectedCandidates";
const ADD_RECRUITER = "/addRecruiter";
const USER_CHAT = "/userchat";
const COMMISSION_MANAGEMENT = '/commission-management'
const BA_PERFORMANCE = '/BA-performance'
const CLIENT_HIRING_SUMMARY = '/reports/clientHiringReport'

const AuthenticatedRoutes = () => {

  const { unreadCount } = useWebSocket();

  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.up("md"));

  const [drawerOpen, setDrawerOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [subMenu, setSubMenu] = useState(null);
  const open = Boolean(subMenu);

  const token = localStorage.getItem("token");

  const { data: getWorkCategoryDropDown, refetch: refetchWorkCategory } = useGetWorkCategoryDropDownQuery(undefined, { skip: !token });
  const { data: getPositionLevelDropDown, refetch: refetchPositionLevel } = useGetPositionLevelDropDownQuery(undefined, { skip: !token });

  useEffect(() => {
    if (token) {
      const timer = setTimeout(() => {
        refetchWorkCategory();
        refetchPositionLevel();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [token]);

  const { Profile } = useSelector((state) => state.common);
  const userRole = Profile?.profile?.role;
  let firstLetter = Profile?.profile?.firstName;
  const letter = firstLetter?.charAt(0)?.toUpperCase();

  const ProfileName = Profile?.profile?.role;
  const isExternalRecruiter = Profile?.profile?.isExternalRecruiter;
  const { Snackbar } = useContext(SnackbarContext);

  const loggedInUser = Profile?.profile?.role?.toLowerCase();
  const isExternal = Profile?.profile?.isExternalRecruiter;

  const handleClick = (event) => {
    setSubMenu(event.currentTarget);
  };

  const handleClose = () => {
    setSubMenu(null);
  };

  const handleChangePswdNav = () => {
    navigate("/change-password");
  };

  const handleProfileNav = () => {
    // navigate('/profile')
    navigate("/profile-view");
  };


  const handleLogout = async () => {
    const microsoft =
      localStorage.getItem("microsoft") === "true" ? "microsoft" : "logout";

    if (microsoft === "microsoft") {
      try {
        Cookies.remove("token");
        localStorage.removeItem("msal.idtoken");
        localStorage.removeItem("msal.access.token");
        localStorage.removeItem("microsoft");
        sessionStorage.clear();
        localStorage.clear();
        dispatch(OnLogout());
        MsInstance.logoutRedirect();
        Snackbar("logged out succussfully ", "success");
      } catch (error) {
        Snackbar("Logout Failed", "error");
      }
    } else {
      Snackbar("Logged out successfully", "success");
      await dispatch(OnLogout());
      persistor.purge();
      persistor.flush();
      localStorage.clear();
      navigate("/");
    }
  };


  const [activeMenu, setActiveMenu] = useState(false);

  const [expanded, setExpanded] = useState(false); // State for accordion

  const [focusedIndex, setFocusedIndex] = useState(null);

  const toggleAccordion = () => {
    setExpanded(!expanded);
  };

  const handlenavigate = (subPath, subIndex) => {
    setFocusedIndex(subIndex);
    if (1 === subPath?.id) {
      navigate("/job-referrals", {});
    } else if (2 === subPath?.id) {
      navigate("/candidate-referrals", {});
    } else if (3 === subPath?.id) {
      navigate("/client-referrals", {});
    }
  };

  const menuItems = [
    {
      label: "Dashboard",
      icon: (props) => <HomeLineIcon {...props} />,
      path: `/dashboard`,
      subPaths: ["/dashboard-manage-events", "/dashboard/submitprofiles"],
      allowedRoles: ["admin", "coordinator", "recruiter"],
      isExternalBA: ["N"],
    },
    {
      label: loggedInUser === "recruiter" ? "Jobs Assigned" : "Job Postings",
      icon: (props) => <BarChartIcon {...props} />,
      path: `/jobpost`,
      subPaths: [
        "/jobpostadd",
        "/jobpostedit",
        "/findprofile",
        "/manage-events",
        "/submitprofiles",
      ],
      allowedRoles: ["admin", "coordinator", "recruiter"],
      isExternalBA: ["N", "Y"],
    },
    {
      label: "Refer a Job",
      icon: (props) => <BarChartIcon {...props} />,
      path: `/refer-jobs`,
      subPaths: [
        "/refer-a-job",
        "/jobpostedit",
        "/referrals/client-edit",
        "/refer-jobs/submitprofiles",
      ],
      allowedRoles: ["recruiter"],
      isExternalBA: ["Y"],
    },
    {
      label:
        loggedInUser === "recruiter"
          ? "Refer a Candidate"
          : "Candidate Profiles",
      icon: (props) => (
        <UsersIcon
          stroke={props?.focused ? "#6941C6" : "#414651"}
          width={16}
          height={16}
        />
      ),
      path: `/candidateprofile`,
      subPaths: [
        "/addcandidateprofile",
        "/editcandidateprofile",
        "/manage-events-candidate",
        "/candidate-view",
        "/joined-candidate-commission",
      ],
      allowedRoles: ["admin", "coordinator", "recruiter"],
      isExternalBA: ["N", "Y"],
    },
    {
      label: loggedInUser === "recruiter" ? "Refer a Client" : "Clients",
      icon: (props) => <UserIcon {...props} />,
      path: `/client`,
      subPaths: ["/client-add", "/client-edit", "/client-view"],
      allowedRoles: ["admin", "coordinator", "recruiter"],
      isExternalBA: ["Y"],
    },
    {
      label: "Keywords",
      icon: (props) => <LetterSpacingIcon {...props} />,
      path: `/manage-keywords`,
      allowedRoles: ["admin", "coordinator"],
    },
    {
      label: "Recruiters & BAs",
      icon: (props) => <UsersCheckIcon {...props} />,
      path: `/recruiter-list`,
      subPaths: [
        "/recruiter-details",
        "/recruiter-edit",
        "/recruiter-editLvl1",
        ,
        "/addRecruiter",
      ],
      allowedRoles: ["admin", "coordinator"],
    },
    {
      label: "Admin/Co-ordinators",
      icon: (props) => <UserCircleIcon {...props} />,
      path: `/admin`,
      subPaths: ["/add-admin", "/edit-admin", "/view-admin/co-ordinators"],
      allowedRoles: ["admin"],
    },
    {
      label: "Referrals",
      icon: (props) => <ReferralsIcon {...props} />,
      path: `/referrals`,
      subPaths: [
        "/referrals/submitprofiles",
        "/referrals/jobpostedit",
        "/referrals/editcandidateprofile",
        "/referrals/client-view",
        "/referrals/client-edit",
        "/referrals/manage-events-candidate",
      ],
      allowedRoles: ["admin"],
    },
    // {
    //   label: "Referral Commission",
    //   icon: (props) => <CommissionIcon {...props} />,
    //   path:
    //     userRole === "admin"
    //       ? `/referral-payments`
    //       : userRole === "recruiter" && `/referral-payments-new`,
    //   subPaths: [
    //     "/Job/referral-payment",
    //     "/candidate/referral-payment",
    //     "/view-job-payments",
    //     "/view-candidate-payments",
    //     "/view-client-payment",
    //     "/view-commissions",
    //   ],
    //   allowedRoles: ["admin", "recruiter"],
    //   isExternalBA: ["Y"],
    // },
    {
      label: "Rewards",
      icon: (props) => <CommissionIcon {...props} />,
      path: `/referral-payments-new`,
      allowedRoles: ["recruiter"],
      isExternalBA: ["Y"],
    },
    {
      label: "Commission Management",
      icon: (props) => <CommissionIcon {...props} />,
      path: '/commission-management',
      subPaths: [
        "/referral-payments",
        "/view-job-payments",
        "/view-candidate-payments",
        "/view-client-payment",
        "/view-commissions",
      ],
      allowedRoles: ["admin", "recruiter"],
    },
    {
      label: "Payments",
      icon: (props) => <PaymentIcon {...props} />,
      path: `/payments`,
      subPaths: ["/payment-history"],
      allowedRoles: ["admin"],
    },
    // {
    //     label: "Referral's",
    //     icon: (props) => <UserCircleIcon {...props} />,
    //     subPaths: ['/job-referrals', '/candidate-referrals', '/client-referrals', "/submitprofiles", "/editcandidateprofile", "/client-view"],
    //     allowedRoles: ['admin'],

    // },
    // {
    //     label: 'Client References',
    //     icon: (props) => <ClientRefUsersIcon {...props} />,
    //     path: `/client-ref`,
    //     subPaths: ['/add-clientref', '/admin-clientref', "/view-client-references"],
    //     allowedRoles: ['admin']
    // },
    {
      label: "Reports",
      icon: (props) => <ClipBoardCheckIcon {...props} />,
      path: `/reports`,
      subPaths: ["/reports/performanceTracker", "/reports/manageEventsReport", '/reports/clientHiringReport'],
      allowedRoles: ["admin" ],
    },
    {
      label: "Audit Logs",
      icon: (props) => <FileIcon {...props} />,
      path: `/audit-logs`,
      allowedRoles: ["admin"],
    },
    {
      label: (
        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          Chat
          {unreadCount > 0 && (
            <span
              style={{
                display: "inline-block",
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "red",
              }}
            />
          )}
        </span>
      ),
      icon: (props) => <MessageCircleMore size={16} />,
      path: `/userchat`,
      allowedRoles: ["admin", "coordinator", "recruiter"],
      isExternalBA: ["N", "Y"],
    },

    {
      label: "Profile",
      icon: (props) => <FileIcon {...props} />,
      path: `/profile-view`,
      allowedRoles: ["recruiter"],
      subPaths: ["/profile"],
      recruiterLevel: ["N"],
    },
  ];

  useEffect(() => {
    const currentScreen = menuItems?.find(
      (item) =>
        item?.path === location?.pathname ||
        item?.subPaths?.includes(location?.pathname)
    );

    const loggedInUser = Profile?.profile?.role?.toLowerCase();
    const isExternal = Profile?.profile?.isExternalRecruiter; // 'Y' or 'N'

    if (currentScreen) {
      const isAllowedRole = currentScreen?.allowedRoles?.includes(loggedInUser);
      const isAllowedExternal = currentScreen?.isExternalBA
        ? currentScreen.isExternalBA.includes(isExternal)
        : true;

      if (!isAllowedRole) {
        if (loggedInUser === "recruiter") {
          navigate("/unAuthorized-page");
          Snackbar("You are not authorized to access this page.", "error");
        } else if (loggedInUser === "coordinator") {
          navigate("/unAuthorized-page");
          Snackbar("You are not authorized to access this page.", "error");
        } else {
          navigate("/unAuthorized-page");
          Snackbar("You are not authorized to access this page.", "error");
        }
      } else if (
        loggedInUser === "recruiter" &&
        !isAllowedExternal &&
        isExternal === "N"
      ) {
        navigate("/unAuthorized-page");
        Snackbar("You are not authorized to access this page.", "error");
      } else if (loggedInUser === "recruiter" && !isAllowedExternal) {
        navigate("/unAuthorized-page");
        Snackbar("You are not authorized to access this page.", "error");
      }
    }
  }, [location.pathname, Profile]);

  const subMenuNames = [
    {
      Name: "Jobs",
      id: 1,
    },
    {
      Name: "Candidates",
      id: 2,
    },
    {
      Name: "Clients",
      id: 3,
    },
  ];
  const itemsToRemove = [
    "recruitersNewPage",
    "newPage",
    "commonsearchfilter",
    "dashboardNewPage",
    "candidateProfileNewPage",
    "clientNewPage",
    "candidateProfileJoinedPage",
    "adminNewPage",
    "paymentsNewPage",
    "candidateProfileSearchValue",
    "tabValue",
    "candidateValue",
    "referralsTab",
    "searchKeyword",
    "TabId"
  ];

  const handleMainNavigation = (path, text) => {
    if (text === "Referral's") {
      setActiveMenu(true);
    } else {
      itemsToRemove.forEach((item) => localStorage.removeItem(item));
      navigate(path);
      setActiveMenu(false);
      setFocusedIndex(false);
    }
  };

  const [accordionOpen, setAccordionOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const [openDelete, setOpenDelete] = useState(false)
  const [deleteReason, setDeleteReason] = useState("");
  const [isloader, setLoader] = useState(false)
  const [deleteAccount] = useRecruiterDeleteAccountMutation()

  const handleOpenDelete = () => {
    setOpenDelete(true)
  }

  const handleCloseDelete = () => {
    setOpenDelete(false)
    setDeleteReason("")
  }

  const handleDeleteAccount = async () => {
    if (!deleteReason.trim()) {
      Snackbar("Please provide a valid reason", "warning");
      return;
    }
    setLoader(true)
    const userId = localStorage.getItem('userId')
    try {
      const payload = {
        recruiterUserId: userId,
        remarks: deleteReason
      }
      const response = await deleteAccount(payload).unwrap()
      setLoader(false)
      if (response?.status === 200) {
        Snackbar(response?.response?.message, 'success')
        handleCloseDelete(false)
        setTimeout(() => {
          handleLogout()
        }, 1000);
      }
    } catch (error) {
      Snackbar('Failed to delete account', 'error')
      console.error("error", error);
    }
  }

  return (
    <Box>
      {/* Drawer starts here */}
      {isMediumScreen && (
        <Drawer
          variant="permanent"
          anchor="left"
          open={drawerOpen}
          sx={{
            position: "relative",
            flex: 1,
            [`& .MuiDrawer-paper`]: {
              // width: 206,
              width: "16%",
              // marginTop: '55px',
              borderColor: "#E9EAEB",
              backgroundColor: "#FFFFFF",
            },
          }}
        >
          {/* Drawer Menus */}
          <div style={{ display: "flex", marginTop: "20px" }}>
            <img
              src={ORLOGO}
              alt="Open Rec logo"
              className="logodrawer"
              draggable={false}
            ></img>
            {/* <IconButton className="MenuIconDrawer" onClick={toggleDrawer}>
                            <MenuIcon sx={{ color: '#fff' }} />
                        </IconButton> */}
          </div>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <List>
              {menuItems
                ?.filter((item) =>
                  ProfileName === "admin" || ProfileName === "coordinator"
                    ? item?.allowedRoles?.includes(ProfileName)
                    : item?.allowedRoles?.includes(ProfileName) &&
                    item?.isExternalBA?.includes(isExternal)
                )
                ?.map((item, index) => {
                  const isFocused =
                    location?.pathname === item?.path ||
                    (item?.subPaths &&
                      item?.subPaths?.some(
                        (sub) =>
                          location?.pathname?.startsWith(sub) &&
                          (location?.pathname === sub ||
                            location?.pathname.startsWith(`${sub}/`))
                      ));

                  if (item.label === "Referral's") {
                    return (
                      <Accordion
                        key={index}
                        expanded={expanded}
                        onChange={toggleAccordion}
                        sx={{
                          boxShadow: "none",
                          border: "none",
                        }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreOutlinedIcon />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                          sx={{
                            backgroundColor: isFocused && "#F4F3FF",
                            color: isFocused && "#6941C6",
                            "&:hover": {
                              backgroundColor: "#F4F3FF",
                            },
                          }}
                        >
                          <RefferlsIcon />
                          <Typography className="accordionSummary">
                            {item.label}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          {subMenuNames?.map((subPath, subIndex) => {
                            return (
                              <ListItem
                                key={subIndex}
                                sx={{
                                  width: "96%",
                                  cursor: "pointer",
                                  marginLeft: "20px",
                                  "&:hover": {
                                    backgroundColor: "#F4F3FF",
                                  },
                                  color:
                                    focusedIndex === subIndex
                                      ? "#6941C6"
                                      : "initial",
                                  backgroundColor:
                                    focusedIndex === subIndex
                                      ? "#F4F3FF"
                                      : "initial",
                                }}
                                onClick={(e) =>
                                  handlenavigate(subPath, subIndex)
                                }
                              >
                                <Typography
                                  sx={{
                                    fontSize: "13px",
                                  }}
                                >
                                  {" "}
                                  {subPath?.Name}
                                </Typography>
                              </ListItem>
                            );
                          })}
                        </AccordionDetails>
                      </Accordion>
                    );
                  }
                  return (
                    <ListItem
                      className="DrawerMenus"
                      // component={Link}
                      // to={item?.path}
                      key={item?.path || index}
                      sx={{
                        backgroundColor: isFocused && "#F4F3FF",
                        color: isFocused && "#6941C6",
                      }}
                      onClick={() => {
                        handleMainNavigation(item?.path, item?.label);
                      }}
                    >
                      {item?.icon({ focused: isFocused })}
                      <Typography
                        className="DrawerMenusText"
                        sx={{
                          boxShadow: "none !important",
                          "&:hover": {
                            boxShadow: "none",
                          },
                          "&:focus": {
                            boxShadow: "none",
                          },
                        }}
                      >
                        {item?.label}
                      </Typography>
                    </ListItem>
                  );
                })}
            </List>



            <Grid2 className="appbarIcons" sx={{ display: 'flex', flexDirection: 'column', mb: 2, gap: 1, width: '100%' }}>
              <Box
                sx={{
                  border: "1px solid #E9EAEB",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column-reverse", // accordion opens upward
                  borderRadius: "10px",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                {/* Accordion Section */}
                <Collapse in={accordionOpen} orientation="vertical" timeout="auto" unmountOnExit>
                  {userRole === "recruiter" && (
                    <Box
                      sx={{
                        width: "100%",
                        backgroundColor: "#F9FAFB",
                        padding: "12px 14px",
                        borderBottom: "1px solid #E9EAEB",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      {/* Work Category */}
                      <Box sx={{ textAlign: "center" }}>
                        <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#333", mb: "6px" }}>
                          Work Category
                        </Typography>
                        <Box sx={{ display: "flex", gap: "6px", justifyContent: "center", flexWrap: "wrap" }}>
                          {getWorkCategoryDropDown?.response?.some((cat) => cat?.isWorkCategory === "Y") ? (
                            getWorkCategoryDropDown?.response?.map(
                              (category) =>
                                category?.isWorkCategory === "Y" && (
                                  <Chip
                                    key={category?.workCategoryId}
                                    label={category?.workCategoryName}
                                    size="small"
                                    sx={{
                                      fontSize: "11px",
                                      fontWeight: 500,
                                      backgroundColor: "#EEF2FF",
                                      color: category?.workCategoryId === 1 ? "#6941C6" : "red",
                                      height: 22,
                                    }}
                                  />
                                )
                            )
                          ) : (
                            <Typography sx={{ fontSize: "11px", color: "#999" }}>
                              No work category chosen. Please select a category to proceed.
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      {/* Position Level */}
                      <Box sx={{ textAlign: "center" }}>
                        <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "#333", mb: "6px" }}>
                          Position Level
                        </Typography>
                        <Box sx={{ display: "flex", gap: "10px", justifyContent: "center", flexWrap: "wrap" }}>
                          {getPositionLevelDropDown?.response?.some((level) => level?.isPositionLevel === "Y") ? (
                            getPositionLevelDropDown?.response?.map((level) => {
                              const displayName =
                                level?.jobPositionLevelName?.toLowerCase().includes("mid")
                                  ? "Mid"
                                  : level?.jobPositionLevelName;

                              return (
                                level?.isPositionLevel === "Y" && (
                                  <Box
                                    key={level?.jobPositionLevelId}
                                    sx={{ display: "flex", alignItems: "center", gap: "4px" }}
                                  >
                                    <Box
                                      sx={{
                                        width: 10,
                                        height: 10,
                                        borderRadius: "50%",
                                        backgroundColor: level?.color || "#999",
                                      }}
                                      className={`status-dot ${level?.jobPositionLevelName?.toLowerCase()}`}
                                    />
                                    <Typography sx={{ fontSize: "11px", color: "#444" }}>
                                      {displayName}
                                    </Typography>
                                  </Box>
                                )
                              );
                            })
                          ) : (
                            <Typography sx={{ fontSize: "11px", color: "#999" }}>
                              You did not select any position level. Please choose a level to continue.
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  )}
                </Collapse>

                {/* Bottom Row with two separate buttons */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    padding: "10px 12px",
                  }}
                >
                  {
                    Profile?.profile?.role === "recruiter" && (
                      <Box
                        onClick={() => setAccordionOpen((prev) => !prev)}
                        sx={{
                          display: "flex",
                          mb: "6px",
                          borderBottom: "1px solid #a6afb8ff",
                          alignItems: "center",
                          justifyContent: "space-between",
                          cursor: "pointer",
                          gap: "10px",
                        }}
                      >
                        <Typography sx={{ fontSize: "11px", fontWeight: 600, color: "#333", mb: "6px" }}>
                          Eligible Works
                        </Typography>
                        {accordionOpen ? (
                          <KeyboardArrowUpIcon sx={{ fontSize: "20px", color: "#555", mb: "6px" }} />
                        ) : (
                          <ExpandMoreIcon sx={{ fontSize: "20px", color: "#555", mb: "6px" }} />
                        )}
                      </Box>
                    )
                  }

                  <Box
                    onClick={handleMenuClick}
                    sx={{ display: "flex", gap: "12px", alignItems: "center", cursor: "pointer" }}
                  >
                    <Avatar
                      sx={{
                        bgcolor: deepPurple[500],
                        width: 38,
                        height: 38,
                        fontSize: "17px",
                      }}
                    >
                      {letter}
                    </Avatar>
                    <Box sx={{ display: "flex", overflow: "hidden", flexDirection: "column" }}>
                      <Tooltip
                        title={Profile?.profile?.firstName}
                        placement="top"
                        arrow
                        slotProps={{
                          tooltip: {
                            sx: {
                              backgroundColor: "#0A0D12",
                              borderRadius: "8px",
                              padding: "8px 12px",
                              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                            },
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: "500",
                            color: "#000",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {Profile?.profile?.firstName}
                        </Typography>
                      </Tooltip>
                      <Typography sx={{ fontSize: "11px", fontWeight: "400", color: "#666" }}>
                        {Profile?.profile?.role === "recruiter" && isExternalRecruiter === "Y"
                          ? "Business Associate"
                          : Profile?.profile?.role === "recruiter" && isExternalRecruiter === "N"
                            ? "Recruiter"
                            : Profile?.profile?.role}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              {/* Dropdown Menu */}
              <Menu
                elevation={1}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                MenuListProps={{ autoFocusItem: false }}
              >
                {Profile?.profile?.role === "recruiter" && (
                  <MenuItem onClick={handleProfileNav} sx={{ fontSize: "14px" }}>
                    <ListItemIcon>
                      <AccountCircleIcon fontSize="small" sx={{ color: "#c8ced3" }} />
                    </ListItemIcon>
                    Profile
                  </MenuItem>
                )}
                <MenuItem onClick={handleChangePswdNav} sx={{ fontSize: "14px" }}>
                  <ListItemIcon>
                    <EditNoteOutlinedIcon fontSize="small" sx={{ color: "#c8ced3" }} />
                  </ListItemIcon>
                  Change Password
                </MenuItem>
                <MenuItem onClick={handleLogout} sx={{ fontSize: "14px", mt: "5px" }}>
                  <ListItemIcon>
                    <Logout fontSize="small" sx={{ color: "#c8ced3" }} />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </Grid2>

          </Box>
        </Drawer>
      )}
      {/* Drawer ends here */}

      {/* Routes for all the screens */}
      <Box
        sx={{
          flexGrow: 1,
          marginLeft: isMediumScreen && "16%",
          transition: "margin-left 0.3s ease",
          width: isMediumScreen ? "84%" : "100%",
        }}
      >
        <Routes>
          <Route path={DASHBOARD_PATH} element={<Dashboard />} />
          <Route
            path={DASHBOARD_MANAGEEVENTS_PATH}
            element={<DashboardManageEvents />}
          />
          <Route path={JOB_POSTINGS_PATH} element={<JobPosting />} />
          <Route
            path={ADD_JOB_POSTINGS_PATH}
            element={<AddJobPostings key="add" />}
          />
          <Route
            path={EDIT_JOB_POSTINGS_PATH}
            element={<AddJobPostings key="edit" />}
          />
          <Route path={JOB_MANAGE_EVENTS_PATH} element={<JobManageEvents />} />
          <Route path={CANDIDATE_PROFILE_PATH} element={<CandidateProfile />} />
          <Route path={CLIENT_PATH} element={<Clients />} />
          <Route
            path={ADD_CANDIDATE_PATH}
            element={<AddCandidate key="add" />}
          />
          <Route
            path={EDIT_CANDIDATE_PATH}
            element={<AddCandidate key="edit" />}
          />
          <Route path={ADD_PROFILE_PATH} element={<AddProfile />} />
          <Route path={ADD_CLIENT_PATH} element={<AddClient key="add" />} />
          <Route path={EDIT_CLIENT_PATH} element={<AddClient key="edit" />} />
          <Route
            path={MANAGE_EVENT_CANDIDATE}
            element={<ManageEventCandidate />}
          />
          <Route path={CLIENT_REFERENCES_PATH} element={<ClientReferences />} />
          <Route
            path={ADD_CLIENT_REFERENCES_PATH}
            element={<AddClientReferences key="Add" />}
          />
          <Route
            path={ADMIN_CLIENT_REFERENCES_PATH}
            element={<AddClientReferences key="Edit" />}
          />
          <Route
            path={EDIT_CLIENT_REFERENCES_PATH}
            element={<AddClientReferences />}
          />
          <Route
            path={MANAGE_EVENT_CANDIDATE}
            element={<ManageEventCandidate />}
          />
          <Route path={RECRUITERS_PATH} element={<Recruiters />} />
          <Route path={RECRUITER_DETAILS_PATH} element={<RecruiterDetails />} />
          <Route
            path={RECRUITER_EDIT_PATH}
            element={<RecruiterProfileEdit />}
          />
          <Route
            path={RECRUITER_EDIT_PATH_LEVEL1}
            element={<RecruiterProfileEditLv1 />}
          />
          <Route path={KEYWORDS_PATH} element={<Keywords />} />
          <Route path={REPORTS_PATH} element={<Reports />} />
          <Route
            path={PERFORMANCE_TRACKER_PATH}
            element={<PerformanceTracker />}
          />
          <Route
            path={MANAGE_EVENTS_REPORTS}
            element={<ManageEventsReports />}
          />
          <Route path={ADMIN} element={<Admin />} />
          <Route path={ADD_ADMIN} element={<AddAdmin key="Add" />} />
          <Route path={EDIT_ADMIN} element={<AddAdmin key="Edit" />} />
          <Route path={AUDIT_LOG_PATH} element={<AuditLog />} />
          <Route path={CHNAGE_PASSWORD} element={<ChangePassword />} />
          <Route path={PROFILE_PATH} element={<RecruiterProfile />} />
          <Route
            path={PROFILE_VIEW}
            element={<ViewProfile handleOpenDelete={handleOpenDelete} />}
          />
          <Route path={VIEW_JOB_PATH} element={<ViewJob />} />
          <Route path={VIEW_CLIENTS} element={<ViewClients />} />
          <Route
            path={VIEW_ADMIN_COORDINATORS}
            element={<ViewAdminCoordinators />}
          />
          <Route
            path={VIEW_CLIENTS_REFERENCES}
            element={<ClientReferencesView />}
          />
          <Route path={REFERRALS} element={<Referrals />} />
          <Route path={VIEW_JOB_REFERRALS} element={<ViewJob />} />
          <Route
            path={EDIT_CANDIDATE_REFERRALS}
            element={<AddCandidate key="edit" />}
          />
          <Route
            path={EDIT_JOB_POSTINGS_REFERRALS}
            element={<AddJobPostings key="edit" />}
          />
          <Route
            path={EDIT_CLIENT_REFERRALS}
            element={<AddClient key="edit" />}
          />
          <Route path={CLIENT_REFERRALS} element={<ClientReferrals />} />
          <Route path={CANDIDATE_REFERRALS} element={<CandidateReferrals />} />
          <Route path={VIEW_CLIENTS_REFERRALS} element={<ViewClients />} />
          <Route
            path={MANAGE_EVENT_CANDIDATE_REFERRALS}
            element={<ManageEventCandidate />}
          />
          <Route path={JOB_REFERRALS} element={<JobReferrals />} />
          <Route path={REFER_JOBS} element={<ReferJobs />} />
          <Route path={NEW_REFERRALS} element={<NewReferrals />} />
          <Route path={VIEW_REFER_A_JOB} element={<ViewJob />} />
          <Route path={REFERRAL_PAYMENTS} element={<ReferralPayment />} />
          <Route
            path={REFERRAL_PAYMENT_SCREEN}
            element={<ReferralPaymentNew />}
          />
          <Route
            path={JOB_REFERRAL_PAYMENT}
            element={<CandidateReferralPayment />}
          />
          <Route
            path={CANDIDATE_REFERRAL_PAYMENT}
            element={<JobReferralPayment />}
          />
          <Route path={VIEW_PAYMENTS} element={<ViewPayments />} />
          <Route
            path={VIEW_CANDIDATE_PAYMENTS}
            element={<ViewCandidatePayments />}
          />
          <Route path={PAYMENTS} element={<Payments />} />
          <Route path={REFER_A_JOB} element={<AddJobPostings />} />
          <Route path={PAYMENT_HISTORY} element={<PaymentHistory />} />
          <Route path={VIEW_CANDIDATE} element={<ViewCandidate />} />
          <Route path={CLIENT_PAYMENT} element={<ClientReferralPayments />} />
          <Route path={VIEW_CLIENT_PAYMENT} element={<ViewClientPayment />} />
          <Route path={DASHBOARD_JOB_OVERVIEW} element={<ViewJob />} />
          <Route path={VIEW_COMMISSIONS} element={<ViewCommissions />} />
          <Route path={UN_AUTH_COMPONENT} element={<UnAuthComponent />} />
          <Route path={REFERRAL_COMMISSION} element={<ReferralCommison />} />
          <Route path={OFFERED_CANDIDATE} element={<OfferedCandidate />} />
          <Route path={SELECTED_CANDIDATE} element={<SelectedCandidate />} />
          <Route path={ADD_RECRUITER} element={<AddRecruiter />} />
          <Route path={USER_CHAT} element={<UserChat />} />
          <Route path={COMMISSION_MANAGEMENT} element={<CommissionManagement />} />
          <Route path={BA_PERFORMANCE} element={<BAPerformance />} />
          <Route path={CLIENT_HIRING_SUMMARY} element={<ClientHiringReport />} />
        </Routes>
      </Box>

      <Grid2 item>
        <Dialog
          open={openDelete}
          onClose={handleCloseDelete}
          // handleLogout={handleLogout}
          scroll="paper"
          maxWidth="xs"
          sx={{
            "& .MuiDialog-paper": {
              width: "90%",
              maxWidth: "500px",
              height: "auto",
              borderRadius: "15px",
              padding: "3px",
            },
          }}
        >
          <DialogContent>
            <div
              style={{
                backgroundColor: "#FEF0C7",
                border: "1px solid #FDB022",
                borderRadius: "8px",
                padding: "12px",
                marginBottom: "20px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "15px",
                  color: "#B54708",
                }}
              >
                Warning
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#7A5B2E",
                }}
              >
                Deleting your account is permanent and cannot be undone.
                Please provide a valid reason to proceed.
              </Typography>
            </div>
            <TextField
              label="Reason for deleting account"
              fullWidth
              multiline
              rows={3}
              value={deleteReason}
              onChange={(e) => setDeleteReason(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                },
              }}
            />
            <Grid2
              item
              sx={{
                marginTop: "25px",
                display: "flex",
                gap: "10px",
                justifyContent: "flex-end",
              }}
            >
              <MUICancelButton title="Cancel" onClick={handleCloseDelete} />
              <MUIButton
                title="Delete Account"
                sx={{
                  backgroundColor: "#D92D20",
                  borderRadius: "10px",
                }}
                onClick={() => handleDeleteAccount(deleteReason)}
              />
            </Grid2>
          </DialogContent>
        </Dialog>
      </Grid2>
    </Box>
  );
};

export default AuthenticatedRoutes;
